module.exports = __webpack_public_path__ + "static/media/service-content-mobile.3885ea2b.svg";